export type ColorsTypes = typeof colors;

export const colors = {
	primary50: '#E6F6FF',
	primary100: '#BAE3FF',
	primary200: '#7CC4FA',
	primary300: '#47A3F3',
	primary400: '#12539E',
	/** 버튼·링크 호버 */
	primaryHover: '#0E4685',
	/** 버튼 액티브 */
	primaryActive: '#0A3569',
	secondary50: '#F2FCFB',
	secondary100: '#C7F7F4',
	secondary200: '#96F2EB',
	secondary300: '#63E6D9',
	secondary400: '#38D9C6',
	tertiary50: '#F2FCFB',
	tertiary100: '#C7F7F4',
	tertiary200: '#96F2EB',
	tertiary300: '#63E6D9',
	tertiary400: '#38D9C6',
	red600: '#DC2626',
	gray: '#F8F9FA',
	gray100: '#E9ECEF',
	gray200: '#ADB5BD',
	grayMid: '#495057',
	grayLight: '#868E96',
	grayDarker: '#212529',
	/** 본문·제목 */
	textPrimary: '#212529',
	textSecondary: '#495057',
	textMuted: '#868E96',
	textTertiary: '#ADB5BD',
	/** 테두리·구분선 */
	borderDefault: '#DEE2E6',
	borderSubtle: '#E9ECEF',
	/** 배경 */
	surfacePage: '#FFFFFF',
	surfaceMuted: '#F8F9FA',
	surfaceHover: '#F1F3F5',
};
